import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { LocalScanningWebApiService } from './app/services/local-scanning-web-api.service';
import { EnvironmentConfigurationService, ScriptLoaderService, SpinnerService, } from '@drc-eca/eca-lrc-common-ui';
import {
  DateAdapter,
  ErrorStateMatcher,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatLineModule,
  MatNativeDateModule
} from '@angular/material/core';
import { ShowOnInvalidErrorStateMatcher } from './app/components/core/error-state';
import { LrcEnvironmentConfigurationService } from './app/services/lrc-environment-configuration.service';
import {
  ECA_DATEPICKER_FORMAT,
  EcaAppShellModule,
  EcaComponentsLibModule,
  EcaDateAdapter,
  EcaDatepickerModule,
  EcaHeaderModule,
  EcaMonotronModule,
  EcaNoResultsModule,
  EcaSearchModule,
  EcaSiteSearchModule,
  EcaSnackbarAlertModule
} from '@drc-eca/eca-components-lib';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { StoreModule } from '@ngrx/store';
import { reducers } from './app/state/reducers';
import { initialState } from './app/state/initialState';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { storeFreeze } from 'ngrx-store-freeze';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './app/state/effects';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { AlertsModule } from './app/components/alerts/alerts.module';
import { AppComponent } from './app/app.component';

const storeDevtoolsModule = !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 2000 }) : [];
const metaReducers = !environment.production ? [storeFreeze] : [];
const ecaModules = [
  EcaAppShellModule,
  EcaComponentsLibModule.forRoot(environment.apiGatewayConfig),
  EcaDatepickerModule,
  EcaHeaderModule,
  EcaMonotronModule,
  EcaNoResultsModule,
  EcaSearchModule,
  EcaSiteSearchModule,
  EcaSnackbarAlertModule,
];
const materialModules = [
  MatBadgeModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatLineModule,
  MatListModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
];

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AlertsModule,
      AppRoutingModule,
      BrowserModule,
      FlexLayoutModule,
      FormsModule,
      ReactiveFormsModule,
      storeDevtoolsModule,
      StoreModule.forRoot(reducers, {
        initialState,
        metaReducers,
      }),
      EffectsModule.forRoot(effects),
      ...materialModules,
      ...ecaModules,
    ),
    LocalScanningWebApiService,
    ScriptLoaderService,
    SpinnerService,
    { provide: ErrorStateMatcher, useClass: ShowOnInvalidErrorStateMatcher },
    { provide: EnvironmentConfigurationService, useClass: LrcEnvironmentConfigurationService },
    { provide: MAT_DATE_FORMATS, useValue: ECA_DATEPICKER_FORMAT },
    { provide: DateAdapter, useClass: EcaDateAdapter, deps: [MAT_DATE_LOCALE] },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ]
}).catch(err => console.log(err));

